"use client";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { ConfirmModalContainerInput } from "@/typings";
import { clsx } from "clsx";

export default function ConfirmModalContainer({
  title,
  additionalTitleStyle,
  additionalContainerStyle,
  confirmButtonText,
  cancelButtonText = "Cancel",
  modalContent,
  onModalConfirm,
  onModalCancel,
  onModalDismiss,
}: ConfirmModalContainerInput) {
  let [isOpen, setIsOpen] = useState(true);
  let [didConfirm, setDidConfirm] = useState(false);

  function closeModal(finalConfirm: boolean) {
    setDidConfirm(finalConfirm);
    if (finalConfirm == true) {
      onModalConfirm?.();
    } else {
      onModalCancel?.();
    }
    setIsOpen(false);
  }

  // function openModal() {
  //   setIsOpen(true);
  //   onModalOpen?.();
  // }

  return (
    <>
      <div className="fixed inset-0 z-[1] flex items-center justify-center backdrop-blur-lg"></div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[2]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto py-5">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
                afterLeave={() => {
                  onModalDismiss?.(didConfirm);
                }}
              >
                <Dialog.Panel
                  className={clsx(
                    "w-full max-w-6xl transform overflow-hidden rounded-2xl bg-base-100 p-6 text-left align-middle shadow-xl transition-all",
                    additionalContainerStyle
                  )}
                >
                  {title && (
                    <Dialog.Title
                      as="h1"
                      className={clsx(
                        "base-content text-2xl font-extrabold leading-6 text-secondary",
                        additionalTitleStyle
                      )}
                    >
                      {title}
                    </Dialog.Title>
                  )}

                  {modalContent}

                  <div className="flex  flex-col items-end space-x-8 ">
                    <div className="divider"></div>
                    {confirmButtonText && (
                      <div className="flex w-full">
                        <button
                          type="button"
                          className="btn  btn-success w-full"
                          onClick={() => {
                            closeModal(true);
                          }}
                        >
                          {confirmButtonText}
                        </button>
                      </div>
                    )}
                    <div className="mt-4 flex w-full">
                      <button
                        type="button"
                        className="btn btn-error w-full"
                        onClick={() => {
                          closeModal(false);
                        }}
                      >
                        {cancelButtonText}
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
